export const TOGGLE_BENEFIT = 'TOGGLE_BENEFIT';
export const SET_SELECTED_BENEFITS = 'SET_SELECTED_BENEFITS';

export const toggleBenefit = benefit => ({
  type: TOGGLE_BENEFIT,
  benefit,
});

export const setSelectedBenefits = benefits => ({
  type: SET_SELECTED_BENEFITS,
  benefits,
});
